$(function () {

	function onElementHeightChange(elm, callback){
    var lastHeight = elm.clientHeight, newHeight;
    (function run(){
        newHeight = elm.clientHeight;
        if( lastHeight != newHeight )
            callback();
        lastHeight = newHeight;

        if( elm.onElementHeightChangeTimer )
            clearTimeout(elm.onElementHeightChangeTimer);

        elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
	}


	onElementHeightChange(document.body, function(){
		parent.postMessage('ffg-height|' + $(document.body).height(), '*');
	});

	var $win = $(window);

	$win.on('resize.broadcastDimensions', function () {
		parent.postMessage('ffg-height|' + $(document.body).height(), '*');
	});

	setTimeout(function () { $win.trigger('resize.broadcastDimensions'); }, 1);

});